import tw from 'twin.macro';

const Container = tw.div`flex items-center gap-[12px] p-[4px] pl-[12px] rounded bg-neutral-background border border-sec-2`;
const Label = tw.div`text-[16px] text-text-and-icon font-medium`;
const Value = tw.div`flex px-[12px] py-[4px] justify-center items-center rounded bg-sec-4 text-[14px] text-accent-1 font-medium`;

export const EpisodeDetailsInfoBadge = ({ label, value }: { label: string; value: string }) => {
  return (
    <Container>
      <Label>{label}</Label>
      <Value>{value}</Value>
    </Container>
  );
};
